/*
 * Puts the Selleasy upsell widget under the control of the "Upsell widget"
 * block of the product template.
 *
 * Selleasy injects <lb-upsell-widget> into the product form itself and ignores
 * the section's block order, so the theme cannot place it with Liquid alone:
 *   - the widget is moved into the block's slot, which is what makes block
 *     ordering work,
 *   - any copy left outside the slot is hidden through
 *     [data-upsell-slot-managing] (see beautifuynew.css), which is what makes
 *     hiding or removing the block hide the widget.
 *
 * Only the Selleasy widget is touched. Dealeasy's volume discount renders where
 * its own app block sits and is ordered and hidden natively by Shopify - do not
 * add it here, moving it breaks its block ordering.
 *
 * Loaded from theme.liquid rather than inline in the section: the theme editor
 * re-renders a section by replacing its HTML, which does not execute inline
 * scripts, so an inline version stops working after the first edit.
 */
(function () {
    var MAX_MOVES = 30;
    var observer = null;

    function currentSlot() {
        var slots = document.querySelectorAll('[data-upsell-slot]');

        // The editor can leave a detached copy of the section behind mid-edit;
        // only a slot that is still in the document can be filled.
        for (var i = slots.length - 1; i >= 0; i--) {
            if (slots[i].isConnected) return slots[i];
        }

        return null;
    }

    function init() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }

        // Set whether or not the block is present: with no slot the widget has
        // nowhere to go, and hiding the block has to hide it.
        document.documentElement.setAttribute(
            'data-upsell-slot-managing',
            'upsell'
        );

        var slot = currentSlot();
        if (!slot) return;

        var column =
            slot.closest('.template-product__information') || document.body;
        var moves = 0;

        function fill() {
            if (!slot.isConnected) {
                init();
                return;
            }

            var widget = column.querySelector('lb-upsell-widget');
            if (!widget || slot.contains(widget) || moves > MAX_MOVES) return;

            var current = slot.querySelector('lb-upsell-widget');
            if (current && current !== widget) current.remove();

            slot.appendChild(widget);
            moves++;
        }

        fill();

        observer = new MutationObserver(fill);
        observer.observe(column, { childList: true, subtree: true });
    }

    function reinit() {
        init();
        // The editor swaps the DOM asynchronously and Selleasy re-injects on
        // its own timer, so run once more when things have settled.
        setTimeout(init, 300);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', reinit);
    document.addEventListener('shopify:section:unload', reinit);
    document.addEventListener('shopify:section:reorder', reinit);
    document.addEventListener('shopify:block:select', reinit);
    document.addEventListener('shopify:block:deselect', reinit);
})();
